import { render, staticRenderFns } from "./BuyerCreateSoftphoneCampaign.vue?vue&type=template&id=d3ca50fc&scoped=true"
import script from "./BuyerCreateSoftphoneCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerCreateSoftphoneCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ca50fc",
  null
  
)

export default component.exports